import appGlobalScript from '/Users/tomstemerding/projects/graphite-design-system/packages/core/src/global/graphite-global.ts';
export const globalScripts = appGlobalScript;
